// Import the styles for webpack bundling
import '../../scss/app.scss'